import { useEffect } from 'react';
/**
 * Hook that alerts clicks outside of the passed ref
 */

export function useOutsideAlerter(ref, setShowOptionList) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var showOptionList = arguments.length > 3 ? arguments[3] : undefined;
  var setFocusSearch = arguments.length > 4 ? arguments[4] : undefined;
  var setFilteredResults = arguments.length > 5 ? arguments[5] : undefined;
  var options = arguments.length > 6 ? arguments[6] : undefined;
  useEffect(function () {
    function handleClickOutside(event) {
      var _ref$current;

      if (ref !== null && ref !== void 0 && ref.current && !(ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event === null || event === void 0 ? void 0 : event.target)) && name === showOptionList) {
        setShowOptionList(false);
        setFocusSearch(false);
        setFilteredResults(options);
      }
    } // Bind the event listener


    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, name, showOptionList]);
}